import '../styles/main.scss';
import { tsParticles } from "@tsparticles/engine";
import { loadStarsPreset } from "@tsparticles/preset-stars";
import gsap from 'gsap';

// Initialize Particles
(async () => {
  await loadStarsPreset(tsParticles);

  await tsParticles.load({
    id: "tsparticles",
    options: {
      preset: "stars",
      background: {
        color: {
            value: "transparent" // Let CSS handle base color
        }
      },
      particles: {
        move: {
            speed: 0.5 // Slow down for "dreamy" effect
        },
        size: {
            value: { min: 0.1, max: 1.5 }
        },
        opacity: {
            value: { min: 0.1, max: 0.8 },
            animation: {
                enable: true,
                speed: 0.5,
                sync: false
            }
        }
      }
    },
  });
})();

// Animations
document.addEventListener('DOMContentLoaded', () => {
    // Hero Animation
    gsap.fromTo('.hero', 
        { y: -50, autoAlpha: 0 },
        { duration: 2, y: 0, autoAlpha: 1, ease: "power3.out", delay: 0.5 }
    );

    // Cards Animation (Staggered)
    gsap.fromTo('.portal-card', 
        { y: 50, autoAlpha: 0 },
        { 
            duration: 1.5, 
            y: 0, 
            autoAlpha: 1, 
            stagger: 0.2, 
            ease: "back.out(1.7)", 
            delay: 1.2,
            onStart: () => console.log("Cards animation started") // Debug log
        }
    );
    
    // Footer Animation
    gsap.from('.footer', {
        duration: 1,
        opacity: 0,
        delay: 2.5
    });
});
